module.exports = __webpack_public_path__ + "static/media/besties-stack-en.4841a00b.png";